import React from 'react';
import { ButtonIcon } from '@workspace/ui/common/Buttons/ButtonIcon';
import { cn } from '@workspace/lib';

interface HeroBannerControlsProps {
  total: number;
  current: number;
  onPrev: () => void;
  onNext: () => void;
  onSlideChange: (index: number) => void;
  size: 'slim' | 'medium' | 'full';
}

export function HeroBannerControls({ total, current, onPrev, onNext, onSlideChange }: HeroBannerControlsProps) {
  if (total <= 1) return null;

  return (
    <>
      <ButtonIcon
        variant="round"
        iconSize={24}
        iconName="ChevronLeft"
        onClick={onPrev}
        ariaLabel="Previous slide"
        className="absolute top-1/2 left-8 -translate-y-1/2 z-30 !bg-transparent"
      />
      <ButtonIcon
        variant="round"
        iconSize={24}
        iconName="ChevronRight"
        onClick={onNext}
        ariaLabel="Next slide"
        className="absolute top-1/2 right-8 -translate-y-1/2 z-30 !bg-transparent"
      />

      <div className={cn('absolute md:bottom-12 bottom-4 left-1/2 -translate-x-1/2 gap-2 z-20 flex')}>
        {Array.from({ length: total }, (_, idx) => (
          <button
            key={idx}
            onClick={() => onSlideChange(idx)}
            type="button"
            className={cn(
              'w-2 h-2 rounded-full transition cursor-pointer',
              current === idx ? 'bg-primary' : 'bg-secondary-100 hover:bg-white/80',
            )}
            aria-label={`Go to slide ${idx + 1} of ${total}`}
            aria-pressed={current === idx}
          />
        ))}
      </div>
    </>
  );
}
